import theme, { createStyles } from 'core/utilities/theme';

export default createStyles({
  buttonGroup: {
    backgroundColor: 'white',
  },
  button: {
    fontSize: '18px',
    lineHeight: '22px',
    minHeight: '30px',
  },
  ml: {
    marginLeft: theme.spacing(1),
  },
  mr: {
    marginRight: theme.spacing(1),
  },
});
